/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const PencilIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "#F59E0B"}
      d="m14.708 4.585-2.794-2.792a1 1 0 0 0-1.414 0L2.793 9.5a.991.991 0 0 0-.293.707V13a1 1 0 0 0 1 1H14a.5.5 0 1 0 0-1H7.708l7-7a1.002 1.002 0 0 0 0-1.415Zm-9.25 7.165 5.646-5.646 1.043 1.042L6.5 12.793 5.458 11.75Zm4.937-6.354L4.75 11.043 3.707 10l5.647-5.646 1.041 1.042ZM3.5 11.206 5.293 13H3.5v-1.793Z"
    />
  </svg>
);
export default PencilIcon;
export const EditPencilIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.2069 4.58563L11.4144 1.7925C11.3215 1.69962 11.2113 1.62594 11.0899 1.57567C10.9686 1.5254 10.8385 1.49953 10.7072 1.49953C10.5759 1.49953 10.4458 1.5254 10.3245 1.57567C10.2031 1.62594 10.0929 1.69962 10 1.7925L2.29313 9.5C2.19987 9.59252 2.12593 9.70266 2.0756 9.82401C2.02528 9.94536 1.99959 10.0755 2.00001 10.2069V13C2.00001 13.2652 2.10536 13.5196 2.2929 13.7071C2.48043 13.8946 2.73479 14 3.00001 14H5.79313C5.9245 14.0004 6.05464 13.9747 6.17599 13.9244C6.29735 13.8741 6.40748 13.8001 6.50001 13.7069L14.2069 6C14.2998 5.90714 14.3734 5.79689 14.4237 5.67555C14.474 5.55421 14.4999 5.42415 14.4999 5.29281C14.4999 5.16147 14.474 5.03142 14.4237 4.91008C14.3734 4.78874 14.2998 4.67849 14.2069 4.58563ZM3.20688 10L8.50001 4.70688L9.54313 5.75L4.25001 11.0425L3.20688 10ZM3.00001 11.2069L4.79313 13H3.00001V11.2069ZM6.00001 12.7931L4.95688 11.75L10.25 6.45688L11.2931 7.5L6.00001 12.7931ZM12 6.79313L9.20688 4L10.7069 2.5L13.5 5.2925L12 6.79313Z"
      fill={props.color || "#3B82F6"}
    />
  </svg>
);
